<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="用户姓名" prop="name">
              <Input disabled="disabled" class="perW30" v-model="infoData.name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="手机号/账号" prop="phone">
              <Input disabled="disabled" class="perW30" v-model="infoData.phone"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="用户类型" prop="type_msg">
              <Input disabled="disabled" class="perW30" v-model="infoData.type_msg"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="管理基地" prop="land_base_name">
              <div class="perW60" style="display: flex;flex-wrap: wrap;">
                <span style="margin-right: 10px;margin-bottom: 10px;padding: 0 6px;border: 1px solid #e9e9e9;border-radius: 10px;color: #515a6e;" v-for="(item, index) in infoData.land_base_name" >{{item}}</span>
              </div>
            </FormItem>
          </Col>

        </Row>

      </Form>
    </card>

  </div>
</template>
<script>
import {landBaseAdminInfoApi} from '@/api/landBase/landBaseAdmin'
import {landBaseAllApi} from "@/api/landBase/landBase";

export default {
  name: 'landBaseAdminInfo',
  data() {
    return {
      infoData: {
        land_base_user_id: 0,
        land_base_name: [],
        name: '',
        phone: '',
        type_msg: '',
      },
      landBaseList: [],
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {

    // 编辑加载数据
    loadFormData(id) {
      landBaseAllApi().then(res => {
        if (res.code === 200) {
          this.landBaseList = res.data

          landBaseAdminInfoApi(id).then(res => {
            //数据赋值
            this.infoData = res.data

            // 提取所有基地名称
            this.infoData.land_base_name = []
            for (let i = 0; i < this.infoData.land_base_id.length; i++) {
              this.infoData.land_base_name.push(this.landBaseList[this.infoData.land_base_id[i]])
            }

          }).catch(res => {
            this.$Message.error(res.msg)
          })


        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })

    },

  }
}
</script>
